import { createFileRoute, notFound } from '@tanstack/react-router';

import { seoArtifactToHead } from '@/config/seo-head';
import { ProjectDetailPage } from '@/features/projects/components/project-detail-page';
import { loadProjectCaseStudy } from '@/features/projects/project-loaders';

export const Route = createFileRoute('/projects/$slug')({
  loader: async ({ params }) => {
    const result = await loadProjectCaseStudy({ data: params.slug });
    if (!result) {
      throw notFound();
    }
    return result;
  },
  head: ({ loaderData }) => {
    if (!loaderData?.project.seo) {
      return {};
    }
    return seoArtifactToHead(loaderData.project.seo);
  },
  component: ProjectDetailRoute,
});

function ProjectDetailRoute() {
  const { project, bodyHtml } = Route.useLoaderData();
  return <ProjectDetailPage project={project} bodyHtml={bodyHtml} />;
}
